export const FETCH_TEAM = "FETCH_TEAM";
export const FETCH_TEAM_LIST = "fetchTeamList";
export const SAVE_MANAGE_TEAM = "updateEcsCompanyDetails";
export const SAVE_EDITED_TEAM = "SAVE_EDITED_TEAM";
export const SAVE_NEW_TEAM = "SAVE_NEW_TEAM";
export const DELETE_TEAM = "DELETE_TEAM";
